import ReferralsClosed from './ReferralsClosed';

export default ReferralsClosed;
